type Props = {
  value: string[];
};

export const ParamReferenceTags: React.FC<Props> = ({ value }) => {
  return (
    <span className="text-lime-800">
      {value.length > 0 ? value.join(', ') : '""'}
    </span>
  );
};
